export enum TipoConteudoEnum {
  'Aula' = 1,
  'Projeto' = 2,
  'Projeto Final' = 3,
}
